import React from "react";
import MaestroLoader from "@components/MaestroLoader";
import { Box, Button, CardCover, Grid, Typography } from "@mui/joy";
import TableWidget from "./layouts/TableWidget";
import { primaryProperty, useGetAllBusinesses } from "@api/businessService";
import ListWidget from "./layouts/ListWidget";
import { useGetProperty } from "@api/propertyService";
import ObjectPreview from "@components/objects/ObjectPreview";
import { useGetWorkPlan } from "@api/workplanService";
import { formatDate, isValidDate } from "@utils/dates";
import { dueDateClassForTask } from "@utils/dueDateClassForTask";
import { Task } from "@components/Task";

//<th>Task</th>
{/* <th style={{width: '15%'}}>Due</th> */}

const columns = [
    {
        id: 'task',
        numeric: false,
        disablePadding: true,
        sortable: true,
        label: 'Task',
        // cellRendersTd: true,
        rowClasses: (row, {parentData, LinkComponent}) => {
            // const isValidDueDate = isValidDate(row.due_date);
            // const dueDate = isValidDate(row.due_date) ? formatDate(row.due_date) : null;
            const isCompleted = row.completed_at && isValidDate(row.completed_at);
            return isCompleted ? 'task-complete' : '';
        },
        cell: (row, {LinkComponent}) => {
            return (<Task task={row}/>)
        }
    },
    {
        id: 'due',
        numeric: false,
        disablePadding: false,
        sortable: false,
        label: 'Due',
        width: '20%',
        classes: (row, {parentData, LinkComponent}) => {
            return dueDateClassForTask(row);
        },
        cell: (row, {parentData, LinkComponent}) => {
            const isValidDueDate = isValidDate(row.due_date);
            const dueDate = isValidDate(row.due_date) ? formatDate(row.due_date) : null;
            const isCompleted = row.completed_at && isValidDate(row.completed_at);

            return (<>
                {isValidDueDate && (<time className={isCompleted ? 'task-complete' : ''}>{dueDate}</time>)}
                {!isValidDueDate && (<>N/A</>)}
            </>)
        }
    },
];

export default function WorkPlanTasksWidget(props) {

    return (
        <ListWidget
            {...props}
            title={(data, parentData) => (<>Tasks of <ObjectPreview object={parentData} to={`/work-plans/${parentData.id}`}>{parentData.name}</ObjectPreview></>)}
            query={useGetWorkPlan}
            relationship={'tasks'}
            columns={columns}
        />
    );
}
